import { render, staticRenderFns } from "./front-stock-age-record.vue?vue&type=template&id=f172d14e"
import script from "./front-stock-age-record.vue?vue&type=script&lang=ts"
export * from "./front-stock-age-record.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports